import {
	useCallback,
	useContext
} from 'react';
import createDataContext from '../services/createDataContext';
import { mapLookupTypes } from '../services/utils';

import { getSnoozeDurations } from '../api/nora/lookups';

import dashboardReducer, {
	REMOVE_ACTIVITY,
	SET_ACTIVITY_LIST,
	SET_IS_IN_SYNC,
	SET_SNOOZE_DURATIONS,
	SET_TABLE_STATE,
	UPDATE_ACTIVITY
} from '../reducers/dashboardReducer';

export let controller = new AbortController();

const initialState = {
	activityList: null,
	isInSync: false,
	snoozeDurations: [],
	tableState: {
		filters: [],
		pageIndex: 0,
		pageSize: 10,
		sortBy: []
	}
};

// init functions
const setSnoozeDurations = async dispatch => {
	try {
		const [ { types } ] = await getSnoozeDurations( controller.signal );

		const mappedTypes = mapLookupTypes( types );

		SET_SNOOZE_DURATIONS( dispatch, controller.signal )( mappedTypes );
	} catch ( error ) {
		// handle
	}
};

const onInit = async dispatch => {
	controller = new AbortController();

	await setSnoozeDurations( dispatch );
};

const onCleanup = () => {
	controller.abort();
};

export const {
	StateContext,
	ActionContext,
	Provider
} = createDataContext( {
	reducer: dashboardReducer,
	initialState,
	controller,
	onInit,
	onCleanup
} );

export function useDashboardState() {
	const state = useContext( StateContext );

	return state;
}

export function useDashboardAction() {
	const dispatch = useContext( ActionContext );

	const removeActivity = useCallback( id => {
		REMOVE_ACTIVITY( dispatch, controller.signal )( id );
	}, [ dispatch ] );

	const setActivityList = useCallback( data => {
		SET_ACTIVITY_LIST( dispatch, controller.signal )( data );
	}, [ dispatch ] );

	const setIsInSync = useCallback( bool => {
		SET_IS_IN_SYNC( dispatch, controller.signal )( bool );
	}, [ dispatch ] );

	const setTableState = useCallback( updateFunc => {
		SET_TABLE_STATE( dispatch, controller.signal )( updateFunc );
	}, [ dispatch ] );

	const updateActivity = useCallback( data => {
		UPDATE_ACTIVITY( dispatch, controller.signal )( data );
	}, [ dispatch ] );

	return {
		removeActivity,
		setActivityList,
		setIsInSync,
		setTableState,
		updateActivity
	};
}
